/** 端点素材规范尺寸。 */
export const MARKUP_POINT_SIZE = 4;

export function clampFontSize(size: number) {
    return Math.max(Math.min(500, Math.floor(size)), 12);
}

export function clampFillWidth(width: number) {
    return Math.max(Math.min(100, Math.floor(width)), 1);
}
